import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from '../../common/form/button';
import { init } from './ordemServicoActions';

function OrdemServicoTabFooter({ onCancel, premium = true }) {
  return (
    <div className={premium ? 'simple-cad-premium-footer' : 'box-footer'}>
      <Button type="button" className="default" icon="close" label="Cancelar" onClick={onCancel} />
    </div>
  );
}

const mapDispatchToProps = dispatch => bindActionCreators({ onCancel: init }, dispatch);

export default connect(null, mapDispatchToProps)(OrdemServicoTabFooter);
